import { createReducer, on } from "@ngrx/store";
import * as dashboardActions from "./dashboard.actions";

export interface DashboardState {
  allPermissions: any | null;
  allPermissionsError: boolean;
  allPermissionsLoading: boolean;
  allBroadcasts: any | null;
  allBroadcastsError: boolean;
  allBroadcastsLoading: boolean;
  allPastors: any | null;
  allPastorsError: boolean;
  allPastorsLoading: boolean;
  allJobs: any | null;
  allJobsError: boolean;
  allJobsLoading: boolean;
}

export const initialState: DashboardState = {
  allPermissions: null,
  allPermissionsError: null,
  allPermissionsLoading: null,
  allBroadcasts: null,
  allBroadcastsError: null,
  allBroadcastsLoading: null,
  allPastors: null,
  allPastorsError: null,
  allPastorsLoading: null,
  allJobs: null,
  allJobsError: null,
  allJobsLoading: null,
};

export const DashboardReducer = createReducer(
  initialState,

  on(dashboardActions.fetchPermissions, (state) => ({
    ...state,
    allPermissions: null,
    allPermissionsError: null,
    allPermissionsLoading: true,
  })),

  on(dashboardActions.fetchPermissionsSuccessful, (state, { permissions }) => ({
    ...state,
    allPermissions: permissions,
    allPermissionsError: false,
    allPermissionsLoading: false,
  })),

  on(dashboardActions.fetchPermissionsFailed, (state) => ({
    ...state,
    allPermissions: null,
    allPermissionsError: true,
    allPermissionsLoading: false,
  })),

  on(dashboardActions.fetchBroadcasts, (state) => ({
    ...state,
    allBroadcasts: null,
    allBroadcastsError: null,
    allBroadcastsLoading: true,
  })),

  on(dashboardActions.fetchBroadcastsSuccessful, (state, { broadcasts }) => ({
    ...state,
    allBroadcasts: broadcasts,
    allBroadcastsError: false,
    allBroadcastsLoading: false,
  })),

  on(dashboardActions.fetchBroadcastsFailed, (state) => ({
    ...state,
    allBroadcasts: null,
    allBroadcastsError: true,
    allBroadcastsLoading: false,
  })),

  on(dashboardActions.fetchPastors, (state) => ({
    ...state,
    allPastors: null,
    allPastorsError: null,
    allPastorsLoading: true,
  })),

  on(dashboardActions.fetchPastorsSuccessful, (state, { pastors }) => ({
    ...state,
    allPastors: pastors,
    allPastorsError: false,
    allPastorsLoading: false,
  })),

  on(dashboardActions.fetchPastorsFailed, (state) => ({
    ...state,
    allPastors: null,
    allPastorsError: true,
    allPastorsLoading: false,
  })),

  on(dashboardActions.fetchJobs, (state) => ({
    ...state,
    allJobs: null,
    allJobsError: null,
    allJobsLoading: true,
  })),

  on(dashboardActions.fetchJobsSuccessful, (state, { jobs }) => ({
    ...state,
    allJobs: jobs,
    allJobsError: false,
    allJobsLoading: false,
  })),

  on(dashboardActions.fetchPastorsFailed, (state) => ({
    ...state,
    allJobs: null,
    allJobsError: true,
    allJobsLoading: false,
  }))
);
